function Loader(props: any) {
  return (
    <svg className="spinner" viewBox="0 0 50 50">
      <circle cx="25" cy="25" r="20" fill="none" />
    </svg>
  );
}

export default Loader;
